export enum EXTENSION_ACTIONS {
  login = 'login',
  logout = 'logout',
  redirect = 'redirect',
  redirectReady = 'redirectReady',
  toggleIframe = 'toggleIframe',
  clickGmail = 'clickGmail',
  openOnFoamAssist = 'openOnFoamAssist',
}

export const CONV_STARTER_ACTION_TYPES = {
  prep1on1Chat: 'prep1on1Chat',
  mentionedBrandsChat: 'mentionedBrandsChat',
  draftEmailPitchChat: 'draftEmailPitchChat',
} as const;
